import React from 'react';
import { PropTypes } from 'prop-types';

import { Icon } from '@ontruck/orc';

const RecurringErrorMessage = ({ className, t, onClick }) => (
  <div className={className}>
    <div>
      <Icon className="icon" glyph="status-warning" />
    </div>
    <span className="">{`${t('Summary:error_recurring')} `}</span>
  </div>
);

RecurringErrorMessage.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
  onClick: PropTypes.func,
};

RecurringErrorMessage.defaultProps = {
  className: '',
  t: (t) => t,
  onClick: () => ({}),
};

export default RecurringErrorMessage;
